import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { faxCountService } from '@/services/features/FaxCountService';

export const useFaxCount = () => {
  const { user, token } = useAuth();
  const [faxCount, setFaxCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchFaxCount = useCallback(async () => {
    if (!user?.id || !token) {
      setFaxCount(0);
      setError(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const count = await faxCountService.getInboundFaxCount(token);
      setFaxCount(count);
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to fetch fax count';
      setFaxCount(0);
      setError(message);
    } finally {
      setLoading(false);
    }
  }, [user?.id, token]);

  useEffect(() => {
    fetchFaxCount();
  }, [fetchFaxCount]);

  return {
    faxCount,
    loading,
    error,
    refetch: fetchFaxCount,
  };
};